import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_th = _resolveComponent("b-th");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_AppIcon = _resolveComponent("AppIcon");
  const _component_date_value = _resolveComponent("date-value");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_evolution_value = _resolveComponent("evolution-value");
  const _component_slot_with_evolution_value = _resolveComponent("slot-with-evolution-value");
  const _component_overlap_bar_value = _resolveComponent("overlap-bar-value");
  const _component_bar_with_value = _resolveComponent("bar-with-value");
  const _component_variable_styled_bar = _resolveComponent("variable-styled-bar");
  const _component_layer_bars = _resolveComponent("layer-bars");
  const _component_bar_slot_with_value = _resolveComponent("bar-slot-with-value");
  const _component_b_table_lite = _resolveComponent("b-table-lite");
  const _component_wrap_table_with_show_more = _resolveComponent("wrap-table-with-show-more");
  const _component_table_with_title = _resolveComponent("table-with-title");
  return _openBlock(), _createBlock(_component_table_with_title, {
    title: "Evolution",
    class: "vendor-period-table",
    onDownload: $options.downloadPerformancePeriodCSV,
    onCopy: $options.copyPerformancePeriodCSV,
    onGoogleSheetDownload: $options.downloadPerformanceGoogleSheet,
    fields: $data.fields,
    loading: $props.loading
  }, {
    "period-selector": _withCtx(() => [_renderSlot(_ctx.$slots, "period-selector")]),
    default: _withCtx(() => [_createVNode(_component_wrap_table_with_show_more, {
      modelValue: $options.period_pager,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.period_pager = $event),
      period: _ctx.period
    }, {
      default: _withCtx(() => [_createVNode(_component_b_table_lite, {
        class: "lite-table lite-table-hoverable period-table vendor-table",
        fields: $data.fields,
        bordered: "",
        responsive: "",
        fixed: "",
        items: $options.items,
        "sticky-header": true,
        tbodyTrClass: item => _ctx.handleRowClass(item, $options.items),
        "no-border-collapse": "",
        onRowClicked: $options.handleRowClick
      }, {
        "thead-top": _withCtx(() => [_createVNode(_component_b_tr, {
          class: "headers"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_th, {
            colspan: "1",
            style: {
              borderRight: 'none'
            }
          }), _createVNode(_component_b_th, {
            colspan: "1",
            "sticky-column": ""
          }), _createVNode(_component_b_th, {
            colspan: "4",
            class: "sell_out left-embrace right-embrace",
            style: _normalizeStyle({
              color: 'var(--market-800)',
              backgroundColor: '#FEF6F1'
            })
          }, {
            default: _withCtx(() => [_createVNode(_component_hug_value, null, {
              default: _withCtx(() => [_createTextVNode("Sell out")]),
              _: 1
            })]),
            _: 1
          }, 8, ["style"]), _createVNode(_component_b_th, {
            colspan: "2"
          }), _createVNode(_component_b_th, {
            colspan: "1",
            class: "sell_in left-embrace right-embrace",
            style: {
              color: '#068481',
              backgroundColor: '#F6FCFC'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_hug_value, null, {
              default: _withCtx(() => [_createTextVNode("Sell in")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        "head()": _withCtx(col => [_createVNode(_component_flex_row, {
          id: `performance-period-table-${col?.column}`,
          styles: {
            justifyContent: col.field.justify,
            ...col.field.thStyle,
            justifySelf: col.field.justify
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
            target: `performance-period-table-${col?.column}`
          }, {
            title: _withCtx(() => [_createElementVNode("div", {
              innerHTML: $options.getDescriptionBasedOnKpiKey(col?.column).title
            }, null, 8, _hoisted_1)]),
            content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey(col?.column).detail), 1)]),
            default: _withCtx(() => [_createElementVNode("div", {
              innerHTML: col?.column === 'period_agg' ? $options.getPeriodColumnTitle : col?.label,
              class: "title"
            }, null, 8, _hoisted_2)]),
            _: 2
          }, 1032, ["target"])]),
          _: 2
        }, 1032, ["id", "styles"])]),
        "cell(selector)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_AppIcon, {
            icon: `zoom-${row.item.selected ? 'out' : 'in'}`,
            color: row.item.selected ? null : '#ADADAD',
            size: 16
          }, null, 8, ["icon", "color"])]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(period_agg)": _withCtx(row => [_createVNode(_component_date_value, {
          value: row.item?.period_agg,
          format: $options.getDateValueFormat,
          styles: {
            justifyContent: 'flex-start',
            ..._ctx.activateDateValueStyles(row)
          },
          loading: $props.loading
        }, null, 8, ["value", "format", "styles", "loading"])]),
        "cell(ordered_revenue_amount)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 8
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`ordered_revenue_amount_evol${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`ordered_revenue_amount_evol${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.maxCharCount?.percentage?.[`ordered_revenue_amount_evol${$data.evolCategory[_ctx.periodCategory]}`],
                showSign: "",
                align: "right",
                tight: ""
              }, null, 8, ["value", "color", "charCount"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_currency_value, {
              value: row.item?.ordered_revenue_amount,
              charCount: $options.maxCharCount?.currency?.ordered_revenue_amount,
              align: "right",
              tight: ""
            }, null, 8, ["value", "charCount"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(shipped_revenue_amount)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 8
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`shipped_revenue_amount_evol${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`shipped_revenue_amount_evol${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.maxCharCount?.percentage?.[`shipped_revenue_amount_evol${$data.evolCategory[_ctx.periodCategory]}`],
                showSign: "",
                align: "right",
                tight: ""
              }, null, 8, ["value", "color", "charCount"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
              value: row.item?.shipped_revenue_amount,
              background: "var(--market-200)",
              borderColor: "var(--market-200)",
              min: $options.minMax?.shipped_revenue_amount?.min,
              max: $options.minMax?.shipped_revenue_amount?.max,
              loading: $props.loading,
              align: "left",
              tight: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_currency_value, {
                value: row.item?.shipped_revenue_amount,
                charCount: $options.maxCharCount?.currency?.shipped_revenue_amount,
                align: "right",
                tight: ""
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(shipped_cogs_amount)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 8
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`shipped_cogs_amount_evol${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`shipped_cogs_amount_evol${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.maxCharCount?.percentage?.[`shipped_cogs_amount_evol${$data.evolCategory[_ctx.periodCategory]}`],
                showSign: "",
                align: "right",
                tight: ""
              }, null, 8, ["value", "color", "charCount"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_currency_value, {
              value: row.item?.shipped_cogs_amount,
              charCount: $options.maxCharCount?.currency?.shipped_cogs_amount,
              align: "right",
              tight: ""
            }, null, 8, ["value", "charCount"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(vendor_return_rate)": _withCtx(row => [_createVNode(_component_bar_with_value, {
          value: row.item?.vendor_return_rate,
          min: $options.minMax?.vendor_return_rate?.min,
          color: "#93999F",
          max: $options.minMax?.vendor_return_rate?.max,
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.vendor_return_rate,
            charCount: $options.maxCharCount?.percentage?.vendor_return_rate + 1.5,
            precision: 1,
            align: "right",
            tight: ""
          }, null, 8, ["value", "charCount"])]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"])]),
        "cell(net_ppm_amount)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px",
            "justify-content": "right"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: row.item?.net_ppm_amount,
            charCount: $options.maxCharCount?.currency?.net_ppm_amount,
            align: "right",
            tight: ""
          }, null, 8, ["value", "charCount"])]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(net_ppm_pc)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 8
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`net_ppm_pc_evol${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`net_ppm_pc_evol${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.maxCharCount?.percentage?.[`net_ppm_pc_evol${$data.evolCategory[_ctx.periodCategory]}`],
                showSign: "",
                align: "right",
                tight: ""
              }, null, 8, ["value", "color", "charCount"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_bar_slot_with_value, {
              loading: $props.loading,
              value: row.item?.net_ppm_pc,
              reverse: "",
              tight: ""
            }, {
              bar: _withCtx(() => [_createVNode(_component_layer_bars, null, {
                default: _withCtx(() => [_createVNode(_component_variable_styled_bar, {
                  value: $options.minMax?.net_ppm_pc?.max,
                  max: $options.minMax?.net_ppm_pc?.max,
                  min: $options.minMax?.net_ppm_pc?.min,
                  color: "#F2F4F8",
                  height: "6"
                }, null, 8, ["value", "max", "min"]), _createVNode(_component_variable_styled_bar, {
                  value: row.item?.net_ppm_pc,
                  max: $options.minMax?.net_ppm_pc?.max,
                  min: $options.minMax?.net_ppm_pc?.min,
                  color: "#4C8EFF",
                  height: "6"
                }, null, 8, ["value", "max", "min"])]),
                _: 2
              }, 1024)]),
              default: _withCtx(() => [_createVNode(_component_percentage_value, {
                value: row.item?.net_ppm_pc,
                charCount: $options.maxCharCount.percentage?.net_ppm_pc
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["loading", "value"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(net_received_inventory_cost_amount_eur)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 8
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`net_received_inventory_cost_amount_eur_evol${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`net_received_inventory_cost_amount_eur_evol${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.maxCharCount?.percentage?.[`net_received_inventory_cost_amount_eur_evol${$data.evolCategory[_ctx.periodCategory]}`],
                showSign: "",
                align: "right",
                tight: ""
              }, null, 8, ["value", "color", "charCount"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
              value: row.item?.net_received_inventory_cost_amount_eur,
              background: "#E6F9F9",
              borderColor: "#E6F9F9",
              min: $options.minMax?.net_received_inventory_cost_amount_eur?.min,
              max: $options.minMax?.net_received_inventory_cost_amount_eur?.max,
              loading: $props.loading,
              align: "left",
              tight: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_currency_value, {
                value: row.item?.net_received_inventory_cost_amount_eur,
                charCount: $options.maxCharCount?.currency?.net_received_inventory_cost_amount_eur,
                align: "right",
                tight: ""
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        _: 1
      }, 8, ["fields", "items", "tbodyTrClass", "onRowClicked"])]),
      _: 1
    }, 8, ["modelValue", "period"])]),
    _: 3
  }, 8, ["onDownload", "onCopy", "onGoogleSheetDownload", "fields", "loading"]);
}